import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ContentList = ({ children, border, noPadding, moreResults }) => {
  const contentListClass = classnames(`content-list-new faux-list`, {
    'border-1 border-color-grey--light border-radius-l': border,
    'content-list-new--no-padding': noPadding,
    'content-list-new--more-results': moreResults,
  });

  return (
    <ul className={contentListClass}>
      {children}
    </ul>
  );
};

ContentList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  border: PropTypes.bool,
  noPadding: PropTypes.bool,
  moreResults: PropTypes.bool,
};

export default ContentList;



// WEBPACK FOOTER //
// ./library/app/components/Global/Lists/ContentList.js